import store from '@/store';
import { isEmptyVal } from '@/utils';
import { JOINT_SALE_SOFT_BUNDLE_TYPE } from '@/views/config/soft-bundle/constant';

// get coupon related extension params
export const getPartnershipParams = () => {
  return {
    ...getPartnershipInnerParams(),
    ...getPromotionCodeParams(),
  };
};

const getPartnershipInnerParams = () => {
  const getters = store.getters;
  /** @type {PartnerReferBean} */
  const partnerRefer = getters.partnerRefer;

  if (isEmptyVal(partnerRefer)) return;

  const baseInfo = {
    jointsaleCode: partnerRefer.jointsaleCode,
    referralCode: partnerRefer.referralCode,
  };

  // from softBundle with price engine drive
  const partnerUseInSoftBundle = getters.partnerUseInSoftBundle;
  const softBundleUseByPriceEngine = getters.softBundleUseByPriceEngine;

  if (partnerUseInSoftBundle && softBundleUseByPriceEngine) {
    // soft bundle validate successful
    if (getters.softBundleState.isSuccess) {
      return {
        ...baseInfo,
        jointsaleType: JOINT_SALE_SOFT_BUNDLE_TYPE.usePriceEngine,
      }
    }

    return {};
  }

  /**
   * if distributeDependPlanList field not config in op, we need check eligible for partner, eligible means send partner params, false means not send partner params
   * distributionDependPlanList is empty means not force to send partner code (only eligible)
   * distributionDependPlanList is not empty means force to send partner code (both eligible/ineligible)
   * @type {boolean}
   */
  const forceSendPartnerCode = isEmptyVal(partnerRefer.rules?.distributionDependPlanList) === false;

  // regardless of whether the verification is successful or not partner, the order needs to be sent jointsaleCode, referralCode
  if (forceSendPartnerCode) {
    return baseInfo;
  }

  if (getters.eligiblePartnerReferOffer) {
    return baseInfo;
  }

  return {};
};

const getPromotionCodeParams = () => {
  const { couponCode } = store.getters.couponState;
  const promotionCode = window.$config(["promoCampaignInfo", "promotion"], "");
  return (promotionCode && couponCode) ? { promotionCode } : {};
};
